import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "employee-coupon-manage" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "page-header" }
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = { class: "query-field" }
const _hoisted_6 = { class: "query-field" }
const _hoisted_7 = { class: "search-actions" }
const _hoisted_8 = { class: "action-toolbar" }
const _hoisted_9 = { class: "toolbar-actions" }
const _hoisted_10 = {
  key: 0,
  class: "coupon-balance"
}
const _hoisted_11 = { class: "mb-4 rounded-xl bg-amber-50 p-4" }
const _hoisted_12 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_13 = { class: "text-lg font-bold text-slate-900" }
const _hoisted_14 = { class: "text-sm text-slate-500" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-3xl font-bold text-amber-600" }
const _hoisted_17 = { class: "mt-4 flex gap-2" }
const _hoisted_18 = { class: "mb-3 flex flex-wrap items-end gap-2" }
const _hoisted_19 = {
  key: 0,
  class: "text-slate-400"
}
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "mb-3 text-sm text-slate-600" }
const _hoisted_22 = {
  key: 0,
  class: "max-h-64 overflow-y-auto rounded bg-red-50 p-3"
}

import { computed, onMounted, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import {
    ArrowLeftOutlined,
    DownloadOutlined,
    ReloadOutlined,
    SearchOutlined,
    UploadOutlined,
  } from '@ant-design/icons-vue';
  import { Modal, message } from 'ant-design-vue';
  import type { TablePaginationConfig } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs from 'dayjs';
  import * as XLSX from 'xlsx';
  import type {
    CustomerAccountAdjustmentDetailModel,
    CustomerAccountRecordModel,
    CustomerAccountRecordSelectRequestModel,
    CustomerModel,
    CustomerSelectRequestModel,
    EmployeeFormModel,
  } from '@/model/customer';
  import {
    addCustomer,
    addCustomerFoodTicket,
    deleteCustomer,
    editCustomer,
    forbidCustomer,
    getCustomerAccountRecordList,
    getCustomerList,
    reduceCustomerFoodTicket,
  } from '@/service/customer';

  interface CouponImportExcelRow {
    员工工号?: unknown;
    员工姓名?: unknown;
    餐券数量?: unknown;
    调整原因?: unknown;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeCouponManageView',
  setup(__props) {

  const router = useRouter();
  const employeeFormOpen = ref(false);
  const employeeSaving = ref(false);
  const deletingEmployeeId = ref<number>();
  const editingEmployee = ref<CustomerModel>();
  const employeeForm = ref<EmployeeFormModel>({
    customerId: '',
    customerName: '',
    customerInfo: '',
    remark: '',
  });
  const employeeLoading = ref(false);
  const employees = ref<CustomerModel[]>([]);
  const employeeIdInput = ref('');
  const employeeNameInput = ref('');
  const employeePage = ref(1);
  const employeePageSize = ref(10);
  const employeeTotal = ref(0);
  const drawerOpen = ref(false);
  const selectedEmployee = ref<CustomerModel>();
  const recordLoading = ref(false);
  const records = ref<CustomerAccountRecordModel[]>([]);
  const recordDateRange = ref<string[]>();
  const recordDirect = ref<1 | 2>();
  const recordPage = ref(1);
  const recordPageSize = ref(10);
  const recordTotal = ref(0);
  const adjustmentOpen = ref(false);
  const adjustmentLoading = ref(false);
  const adjustmentType = ref<'add' | 'reduce'>('add');
  const adjustmentQuantity = ref<number>();
  const adjustmentRemark = ref('');
  const exportLoading = ref(false);
  const importFileInput = ref<HTMLInputElement>();
  const importType = ref<'add' | 'reduce'>('add');
  const importModalOpen = ref(false);
  const importSubmitting = ref(false);
  const importFileName = ref('');
  const importRows = ref<CustomerAccountAdjustmentDetailModel[]>([]);
  const importErrors = ref<string[]>([]);

  const drawerWidth = computed(() => (window.innerWidth < 768 ? '100%' : 760));
  const employeePagination = computed<TablePaginationConfig>(() => ({
    current: employeePage.value,
    pageSize: employeePageSize.value,
    total: employeeTotal.value,
    showSizeChanger: true,
    showTotal: (total: number) => `共 ${total} 名员工`,
  }));
  const recordPagination = computed<TablePaginationConfig>(() => ({
    current: recordPage.value,
    pageSize: recordPageSize.value,
    total: recordTotal.value,
    showSizeChanger: true,
    showTotal: (total: number) => `共 ${total} 条流水`,
  }));

  const employeeColumns = [
    { title: '员工工号', dataIndex: 'customerId', key: 'customerId', width: 120 },
    { title: '员工姓名', dataIndex: 'customerName', key: 'customerName', width: 160 },
    { title: '餐券余额', dataIndex: 'foodTicketAccount', key: 'foodTicketAccount', width: 120 },
    { title: '微信绑定', key: 'wechatBinding', width: 140 },
    { title: '状态', key: 'status', width: 100 },
    { title: '操作', key: 'action', width: 260, fixed: 'right' },
  ];
  const recordColumns = [
    { title: '时间', dataIndex: 'createTime', key: 'createTime', width: 170, fixed: 'left' },
    { title: '方向', key: 'direct', width: 80 },
    { title: '变化数量', key: 'accountQuantity', width: 110 },
    {
      title: '变化前',
      dataIndex: 'beforeAccountQuantity',
      key: 'beforeAccountQuantity',
      width: 90,
    },
    { title: '变化后', key: 'afterAccountQuantity', width: 90 },
    { title: '餐厅', dataIndex: 'shopName', key: 'shopName', width: 140 },
    { title: '来源', key: 'source', width: 200 },
    { title: '来源备注', dataIndex: 'sourceRemark', key: 'sourceRemark', width: 200 },
    { title: '操作人', dataIndex: 'createBy', key: 'createBy', width: 120 },
  ];
  const importPreviewColumns = [
    { title: '员工工号', dataIndex: 'customerId', key: 'customerId', width: 110 },
    { title: '员工姓名', dataIndex: 'customerName', key: 'customerName', width: 120 },
    { title: '餐券数量', dataIndex: 'accountQuantity', key: 'accountQuantity', width: 100 },
    { title: '调整原因', dataIndex: 'sourceRemark', key: 'sourceRemark', width: 220 },
  ];

  const formatQuantity = (value: number): string =>
    Number(value || 0).toLocaleString('zh-CN', { maximumFractionDigits: 2 });

  const calculateAfterQuantity = (record: CustomerAccountRecordModel): number =>
    record.direct === 1
      ? record.beforeAccountQuantity + record.accountQuantity
      : record.beforeAccountQuantity - record.accountQuantity;

  const loadEmployees = async (): Promise<void> => {
    const customerIdText = employeeIdInput.value.trim();
    if (customerIdText && !/^\d+$/.test(customerIdText)) {
      message.warning('员工工号只能输入数字');
      return;
    }
    const request: CustomerSelectRequestModel = {
      pageNum: employeePage.value,
      pageSize: employeePageSize.value,
      data: {
        type: 1,
        status: 0,
        customerId: customerIdText ? Number(customerIdText) : undefined,
        customerName: employeeNameInput.value.trim() || undefined,
      },
    };
    employeeLoading.value = true;
    try {
      const response = await getCustomerList(request);
      if (response.code !== 200) {
        message.error(response.msg || '员工列表查询失败');
        return;
      }
      const availableEmployees = (response.result?.list || []).filter(
        (item) => item.disabled === 0,
      );
      employees.value = availableEmployees;
      employeeTotal.value = response.result?.total || 0;
    } catch (error) {
      console.error('员工列表查询失败:', error);
      message.error('员工列表查询失败，请稍后重试');
    } finally {
      employeeLoading.value = false;
    }
  };

  const openEmployeeForm = (employee?: CustomerModel): void => {
    if (employeeSaving.value) return;
    editingEmployee.value = employee ? { ...employee } : undefined;
    employeeForm.value = {
      customerId: employee ? String(employee.customerId) : '',
      customerName: employee?.customerName || '',
      customerInfo: employee?.customerInfo ?? '',
      remark: employee?.remark ?? '',
    };
    employeeFormOpen.value = true;
  };

  const submitEmployee = async (): Promise<void> => {
    if (employeeSaving.value) return;
    const employee = editingEmployee.value;
    const customerIdText = employeeForm.value.customerId.trim();
    const customerId = Number(customerIdText);
    const customerName = employeeForm.value.customerName.trim();
    if (!/^\d+$/.test(customerIdText) || !Number.isSafeInteger(customerId) || customerId <= 0) {
      message.warning('员工工号必须为有效的正整数');
      return;
    }
    if (!customerName) {
      message.warning('请输入员工姓名');
      return;
    }
    const { customerInfo, remark } = employeeForm.value;
    const id = employee?.id;
    const customerType = employee?.customerType;
    employeeSaving.value = true;
    try {
      if (employee && (id == null || customerType == null)) {
        message.error('员工数据不完整，请刷新列表后重试');
        return;
      }
      const response =
        employee && id != null && customerType != null
          ? await editCustomer({
              id,
              customerType,
              customerInfo,
              remark,
            })
          : await addCustomer({ customerId, customerName, type: 1, customerInfo, remark });
      if (response.code !== 200) {
        message.error(response.msg || '员工保存失败');
        return;
      }
      if (employee && selectedEmployee.value?.customerId === employee.customerId) {
        selectedEmployee.value = { ...selectedEmployee.value, customerInfo, remark };
      }
      employeeFormOpen.value = false;
      message.success(employee ? '员工修改成功' : '员工新增成功');
      if (!employee) employeePage.value = 1;
      await loadEmployees();
    } catch (error) {
      console.error('员工保存失败:', error);
      message.error('员工保存失败，请稍后重试');
    } finally {
      employeeSaving.value = false;
    }
  };

  const confirmDeleteEmployee = (employee: CustomerModel): void => {
    if (deletingEmployeeId.value !== undefined) return;
    if (employee.id == null) {
      message.error('员工数据不完整，请刷新列表后重试');
      return;
    }
    const employeeId = employee.id;
    Modal.confirm({
      title: '确认删除员工？',
      content: `将删除员工“${employee.customerName}”（工号 ${employee.customerId}），请确认是否继续。`,
      okText: '确认删除',
      okType: 'danger',
      cancelText: '取消',
      async onOk(): Promise<void> {
        deletingEmployeeId.value = employeeId;
        try {
          const forbidResponse = await forbidCustomer({ id: employeeId, status: 1 });
          if (forbidResponse.code !== 200) {
            throw new Error(forbidResponse.msg || '员工禁用失败，未执行删除');
          }
          const response = await deleteCustomer({ id: employeeId });
          if (response.code !== 200) {
            throw new Error(response.msg || '员工已禁用，但删除失败');
          }
          if (selectedEmployee.value?.id === employeeId) {
            drawerOpen.value = false;
            selectedEmployee.value = undefined;
          }
          if (employees.value.length === 1 && employeePage.value > 1) {
            employeePage.value -= 1;
          }
          message.success('员工删除成功');
          await loadEmployees();
        } catch (error) {
          console.error('员工删除失败:', error);
          message.error(error instanceof Error ? error.message : '员工删除失败，请稍后重试');
          throw error;
        } finally {
          deletingEmployeeId.value = undefined;
        }
      },
    });
  };

  const handleSearch = (): void => {
    employeePage.value = 1;
    void loadEmployees();
  };

  const handleReset = (): void => {
    employeeIdInput.value = '';
    employeeNameInput.value = '';
    employeePage.value = 1;
    void loadEmployees();
  };

  const handleEmployeeTableChange = (pagination: TablePaginationConfig): void => {
    employeePage.value = pagination.current || 1;
    employeePageSize.value = pagination.pageSize || 10;
    void loadEmployees();
  };

  const fetchAllEmployees = async (): Promise<CustomerModel[]> => {
    const pageSize = 500;
    let pageNum = 1;
    let total = 0;
    const result: CustomerModel[] = [];
    do {
      const response = await getCustomerList({
        pageNum,
        pageSize,
        data: { type: 1, status: 0 },
      });
      if (response.code !== 200) throw new Error(response.msg || '员工数据查询失败');
      const pageRows = response.result?.list || [];
      result.push(...pageRows.filter((item) => item.disabled === 0));
      total = response.result?.total || 0;
      if (pageRows.length === 0) break;
      pageNum += 1;
    } while ((pageNum - 1) * pageSize < total);
    return result;
  };

  const exportAllEmployees = async (): Promise<void> => {
    exportLoading.value = true;
    try {
      const allEmployees = await fetchAllEmployees();
      if (allEmployees.length === 0) {
        message.warning('没有可导出的员工数据');
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(
        allEmployees.map((employee) => ({
          员工工号: String(employee.customerId),
          员工姓名: employee.customerName,
          餐券余额: employee.foodTicketAccount || 0,
          状态: employee.status === 0 && employee.disabled === 0 ? '正常' : '不可用',
        })),
      );
      worksheet['!cols'] = [{ wch: 16 }, { wch: 18 }, { wch: 14 }, { wch: 12 }];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '员工餐券');
      XLSX.writeFile(workbook, `员工餐券全量_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`);
      message.success(`成功导出 ${allEmployees.length} 名员工`);
    } catch (error) {
      console.error('员工餐券导出失败:', error);
      message.error(error instanceof Error ? error.message : '员工餐券导出失败，请稍后重试');
    } finally {
      exportLoading.value = false;
    }
  };

  const downloadImportTemplate = (): void => {
    const worksheet = XLSX.utils.json_to_sheet([
      {
        员工工号: '10001',
        员工姓名: '张三',
        餐券数量: 10,
        调整原因: '示例：月度餐券发放',
      },
    ]);
    worksheet['!cols'] = [{ wch: 16 }, { wch: 18 }, { wch: 14 }, { wch: 30 }];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '餐券调整导入');
    XLSX.writeFile(workbook, '员工餐券批量调整模板.xlsx');
  };

  const resetImportState = (): void => {
    importModalOpen.value = false;
    importFileName.value = '';
    importRows.value = [];
    importErrors.value = [];
    if (importFileInput.value) importFileInput.value.value = '';
  };

  const openImportFilePicker = (type: 'add' | 'reduce'): void => {
    resetImportState();
    importType.value = type;
    importFileInput.value?.click();
  };

  const validateImportRows = (
    rows: CouponImportExcelRow[],
    headers: string[],
    employeeMap: Map<number, CustomerModel>,
  ): CustomerAccountAdjustmentDetailModel[] => {
    const requiredHeaders = ['员工工号', '员工姓名', '餐券数量', '调整原因'];
    const errors = requiredHeaders
      .filter((header) => !headers.includes(header))
      .map((header) => `缺少必填列：${header}`);
    const result: CustomerAccountAdjustmentDetailModel[] = [];
    const employeeIds = new Set<number>();
    rows.forEach((row, index) => {
      const excelRow = index + 2;
      const rawId = row['员工工号'];
      const rawName = String(row['员工姓名'] ?? '').trim();
      const rawQuantity = row['餐券数量'];
      const rawRemark = String(row['调整原因'] ?? '').trim();
      const isBlank = [rawId, rawName, rawQuantity, rawRemark].every(
        (value) => value === undefined || value === null || value === '',
      );
      if (isBlank) return;
      const customerId = Number(rawId);
      const accountQuantity = Number(rawQuantity);
      const employee = employeeMap.get(customerId);
      let valid = true;
      if (!Number.isSafeInteger(customerId) || customerId <= 0) {
        errors.push(`第 ${excelRow} 行：员工工号必须为正整数`);
        valid = false;
      } else if (employeeIds.has(customerId)) {
        errors.push(`第 ${excelRow} 行：员工工号 ${customerId} 重复`);
        valid = false;
      } else if (!employee) {
        errors.push(`第 ${excelRow} 行：未找到正常状态的员工 ${customerId}`);
        valid = false;
      } else if (rawName !== employee.customerName) {
        errors.push(`第 ${excelRow} 行：员工姓名与工号 ${customerId} 不匹配`);
        valid = false;
      }
      if (!Number.isFinite(accountQuantity) || accountQuantity <= 0) {
        errors.push(`第 ${excelRow} 行：餐券数量必须为大于 0 的数字`);
        valid = false;
      } else if (
        importType.value === 'reduce' &&
        employee &&
        accountQuantity > employee.foodTicketAccount
      ) {
        errors.push(
          `第 ${excelRow} 行：扣减数量 ${accountQuantity} 超过当前余额 ${employee.foodTicketAccount}`,
        );
        valid = false;
      }
      if (!rawRemark) {
        errors.push(`第 ${excelRow} 行：调整原因不能为空`);
        valid = false;
      } else if (rawRemark.length > 200) {
        errors.push(`第 ${excelRow} 行：调整原因不能超过 200 个字符`);
        valid = false;
      }
      if (valid && employee) {
        employeeIds.add(customerId);
        result.push({
          customerId,
          customerName: employee.customerName,
          recordType: 1,
          accountQuantity,
          sourceRemark: rawRemark,
        });
      }
    });
    if (rows.length === 0 || (result.length === 0 && errors.length === 0)) {
      errors.push('Excel 中没有可导入的数据');
    }
    importErrors.value = errors;
    return result;
  };

  const handleImportFileChange = async (event: Event): Promise<void> => {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;
    importFileName.value = file.name;
    importModalOpen.value = true;
    importRows.value = [];
    importErrors.value = [];
    try {
      const [workbook, allEmployees] = await Promise.all([
        file.arrayBuffer().then((buffer) => XLSX.read(buffer, { type: 'array' })),
        fetchAllEmployees(),
      ]);
      const sheetName = workbook.SheetNames[0];
      if (!sheetName) {
        importErrors.value = ['Excel 中没有工作表'];
        return;
      }
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json<CouponImportExcelRow>(sheet, { defval: '' });
      const headerRows = XLSX.utils.sheet_to_json<unknown[]>(sheet, { header: 1, range: 0 });
      const headers = (headerRows[0] || []).map((header) => String(header).trim());
      const employeeMap = new Map(allEmployees.map((employee) => [employee.customerId, employee]));
      importRows.value = validateImportRows(rows, headers, employeeMap);
    } catch (error) {
      console.error('解析员工餐券 Excel 失败:', error);
      importErrors.value = [
        error instanceof Error ? error.message : '文件无法解析，请确认文件是有效的 Excel 格式',
      ];
    }
  };

  const submitBatchImport = async (): Promise<void> => {
    if (importRows.value.length === 0 || importErrors.value.length > 0) return;
    importSubmitting.value = true;
    try {
      const request = { detailsList: importRows.value };
      const response =
        importType.value === 'add'
          ? await addCustomerFoodTicket(request)
          : await reduceCustomerFoodTicket(request);
      if (response.code !== 200) {
        message.error(response.msg || '批量调整餐券失败');
        return;
      }
      message.success(
        `成功${importType.value === 'add' ? '增加' : '扣减'} ${
          importRows.value.length
        } 名员工的餐券`,
      );
      resetImportState();
      await loadEmployees();
      if (selectedEmployee.value) {
        await refreshSelectedEmployee();
        recordPage.value = 1;
        await loadRecords();
      }
    } catch (error) {
      console.error('批量调整餐券失败:', error);
      message.error('批量调整餐券失败，请稍后重试');
    } finally {
      importSubmitting.value = false;
    }
  };

  const loadRecords = async (): Promise<void> => {
    if (!selectedEmployee.value) return;
    const request: CustomerAccountRecordSelectRequestModel = {
      pageNum: recordPage.value,
      pageSize: recordPageSize.value,
      createtimeBegin: recordDateRange.value?.[0]
        ? `${recordDateRange.value[0]} 00:00:00`
        : undefined,
      createtimeEnd: recordDateRange.value?.[1]
        ? `${recordDateRange.value[1]} 23:59:59`
        : undefined,
      data: {
        customerId: selectedEmployee.value.customerId,
        customerName: selectedEmployee.value.customerName,
        recordType: 1,
        direct: recordDirect.value,
      },
    };
    recordLoading.value = true;
    try {
      const response = await getCustomerAccountRecordList(request);
      if (response.code !== 200) {
        message.error(response.msg || '餐券流水查询失败');
        return;
      }
      records.value = response.result?.list || [];
      recordTotal.value = response.result?.total || 0;
    } catch (error) {
      console.error('餐券流水查询失败:', error);
      message.error('餐券流水查询失败，请稍后重试');
    } finally {
      recordLoading.value = false;
    }
  };

  const openEmployeeDetail = (employee: CustomerModel): void => {
    selectedEmployee.value = { ...employee };
    records.value = [];
    recordDateRange.value = undefined;
    recordDirect.value = undefined;
    recordPage.value = 1;
    drawerOpen.value = true;
    void loadRecords();
  };

  const searchRecords = (): void => {
    recordPage.value = 1;
    void loadRecords();
  };

  const resetRecordFilters = (): void => {
    recordDateRange.value = undefined;
    recordDirect.value = undefined;
    recordPage.value = 1;
    void loadRecords();
  };

  const handleRecordTableChange = (pagination: TablePaginationConfig): void => {
    recordPage.value = pagination.current || 1;
    recordPageSize.value = pagination.pageSize || 10;
    void loadRecords();
  };

  const openAdjustment = (type: 'add' | 'reduce'): void => {
    adjustmentType.value = type;
    adjustmentQuantity.value = undefined;
    adjustmentRemark.value = '';
    adjustmentOpen.value = true;
  };

  const refreshSelectedEmployee = async (): Promise<void> => {
    if (!selectedEmployee.value) return;
    const response = await getCustomerList({
      pageNum: 1,
      pageSize: 10,
      data: { type: 1, status: 0, customerId: selectedEmployee.value.customerId },
    });
    const refreshed = response.result?.list?.find(
      (item) => item.customerId === selectedEmployee.value?.customerId && item.disabled === 0,
    );
    if (response.code === 200 && refreshed) selectedEmployee.value = refreshed;
  };

  const executeAdjustment = async (): Promise<void> => {
    if (!selectedEmployee.value || !adjustmentQuantity.value) return;
    adjustmentLoading.value = true;
    try {
      const request = {
        detailsList: [
          {
            customerId: selectedEmployee.value.customerId,
            customerName: selectedEmployee.value.customerName,
            recordType: 1 as const,
            accountQuantity: adjustmentQuantity.value,
            sourceRemark: adjustmentRemark.value.trim(),
          },
        ],
      };
      const response =
        adjustmentType.value === 'add'
          ? await addCustomerFoodTicket(request)
          : await reduceCustomerFoodTicket(request);
      if (response.code !== 200) {
        message.error(response.msg || '餐券调整失败');
        return;
      }
      message.success(adjustmentType.value === 'add' ? '餐券增加成功' : '餐券扣减成功');
      adjustmentOpen.value = false;
      await Promise.all([refreshSelectedEmployee(), loadEmployees()]);
      recordPage.value = 1;
      await loadRecords();
    } catch (error) {
      console.error('餐券调整失败:', error);
      message.error('餐券调整失败，请稍后重试');
    } finally {
      adjustmentLoading.value = false;
    }
  };

  const submitAdjustment = (): void => {
    const quantity = adjustmentQuantity.value;
    const remark = adjustmentRemark.value.trim();
    if (!quantity || !Number.isFinite(quantity) || quantity <= 0) {
      message.warning('请输入大于 0 的有效数量');
      return;
    }
    if (
      adjustmentType.value === 'reduce' &&
      quantity > (selectedEmployee.value?.foodTicketAccount || 0)
    ) {
      message.warning('扣减数量不能超过当前餐券余额');
      return;
    }
    if (!remark) {
      message.warning('请输入调整原因');
      return;
    }
    Modal.confirm({
      title: adjustmentType.value === 'add' ? '确认增加餐券？' : '确认扣减餐券？',
      content: `${selectedEmployee.value?.customerName}（工号 ${
        selectedEmployee.value?.customerId
      }），${adjustmentType.value === 'add' ? '增加' : '扣减'} ${formatQuantity(
        quantity,
      )} 张。原因：${remark}`,
      okText: '确认',
      cancelText: '取消',
      onOk: executeAdjustment,
    });
  };

  onMounted(() => void loadEmployees());

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "page-back-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
            }, [
              _createVNode(_unref(ArrowLeftOutlined))
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "page-title" }, "员工餐券管理", -1))
          ]),
          _createVNode(_component_a_card, { bordered: false }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-1 text-sm text-slate-600" }, "员工工号", -1)),
                  _createVNode(_component_a_input, {
                    value: employeeIdInput.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((employeeIdInput).value = $event)),
                    "allow-clear": "",
                    inputmode: "numeric",
                    placeholder: "请输入员工工号",
                    onPressEnter: handleSearch
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mb-1 text-sm text-slate-600" }, "员工姓名", -1)),
                  _createVNode(_component_a_input, {
                    value: employeeNameInput.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((employeeNameInput).value = $event)),
                    "allow-clear": "",
                    placeholder: "请输入员工姓名",
                    onPressEnter: handleSearch
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    loading: employeeLoading.value,
                    onClick: handleSearch
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SearchOutlined)),
                      _cache[23] || (_cache[23] = _createTextVNode("查询 ", -1))
                    ]),
                    _: 1,
                    __: [23]
                  }, 8, ["loading"]),
                  _createVNode(_component_a_button, { onClick: handleReset }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ReloadOutlined)),
                      _cache[24] || (_cache[24] = _createTextVNode("重置", -1))
                    ]),
                    _: 1,
                    __: [24]
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "toolbar-description" }, "查询员工餐券余额、使用流水并进行人工调整", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openEmployeeForm()))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("新增员工", -1)
                    ])),
                    _: 1,
                    __: [25]
                  }),
                  _createVNode(_component_a_button, {
                    loading: exportLoading.value,
                    onClick: exportAllEmployees
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DownloadOutlined)),
                      _cache[26] || (_cache[26] = _createTextVNode("全量导出 Excel ", -1))
                    ]),
                    _: 1,
                    __: [26]
                  }, 8, ["loading"]),
                  _createVNode(_component_a_button, { onClick: downloadImportTemplate }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DownloadOutlined)),
                      _cache[27] || (_cache[27] = _createTextVNode("下载导入模板 ", -1))
                    ]),
                    _: 1,
                    __: [27]
                  }),
                  _createVNode(_component_a_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (openImportFilePicker('add')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _cache[28] || (_cache[28] = _createTextVNode("批量增加 ", -1))
                    ]),
                    _: 1,
                    __: [28]
                  }),
                  _createVNode(_component_a_button, {
                    danger: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (openImportFilePicker('reduce')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _cache[29] || (_cache[29] = _createTextVNode("批量扣减 ", -1))
                    ]),
                    _: 1,
                    __: [29]
                  })
                ]),
                _createElementVNode("input", {
                  ref_key: "importFileInput",
                  ref: importFileInput,
                  class: "hidden",
                  type: "file",
                  accept: ".xlsx,.xls",
                  onChange: handleImportFileChange
                }, null, 544)
              ]),
              _createVNode(_component_a_table, {
                "row-key": "customerId",
                columns: employeeColumns,
                "data-source": employees.value,
                loading: employeeLoading.value,
                pagination: employeePagination.value,
                scroll: { x: 900 },
                onChange: handleEmployeeTableChange
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'foodTicketAccount')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(formatQuantity(record.foodTicketAccount)), 1))
                    : (column.key === 'wechatBinding')
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: record.openId?.trim() ? 'green' : 'default'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.openId?.trim() ? '已绑定微信' : '未绑定'), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]))
                      : (column.key === 'status')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 2,
                            color: record.status === 0 && record.disabled === 0 ? 'green' : 'default'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.status === 0 && record.disabled === 0 ? '正常' : '不可用'), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : (column.key === 'action')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createVNode(_component_a_button, {
                                type: "link",
                                size: "small",
                                onClick: ($event: any) => (openEmployeeForm(record))
                              }, {
                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                  _createTextVNode(" 修改 ", -1)
                                ])),
                                _: 2,
                                __: [31]
                              }, 1032, ["onClick"]),
                              _createVNode(_component_a_button, {
                                type: "link",
                                size: "small",
                                onClick: ($event: any) => (openEmployeeDetail(record))
                              }, {
                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                  _createTextVNode(" 查看与调整 ", -1)
                                ])),
                                _: 2,
                                __: [32]
                              }, 1032, ["onClick"]),
                              _createVNode(_component_a_button, {
                                type: "link",
                                danger: "",
                                size: "small",
                                loading: deletingEmployeeId.value === record.id,
                                disabled: deletingEmployeeId.value !== undefined,
                                onClick: ($event: any) => (confirmDeleteEmployee(record))
                              }, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode(" 删除 ", -1)
                                ])),
                                _: 2,
                                __: [33]
                              }, 1032, ["loading", "disabled", "onClick"])
                            ], 64))
                          : _createCommentVNode("", true)
                ]),
                emptyText: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("暂无员工数据", -1)
                ])),
                _: 1
              }, 8, ["data-source", "loading", "pagination"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_modal, {
          open: employeeFormOpen.value,
          "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((employeeFormOpen).value = $event)),
          title: editingEmployee.value ? '修改员工' : '新增员工',
          "confirm-loading": employeeSaving.value,
          closable: !employeeSaving.value,
          "mask-closable": !employeeSaving.value,
          keyboard: !employeeSaving.value,
          "cancel-button-props": { disabled: employeeSaving.value },
          width: 520,
          "ok-text": "保存",
          "cancel-text": "取消",
          onOk: submitEmployee
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              layout: "vertical",
              disabled: employeeSaving.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "员工工号",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: employeeForm.value.customerId,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((employeeForm.value.customerId) = $event)),
                      readonly: !!editingEmployee.value,
                      inputmode: "numeric",
                      placeholder: "请输入员工工号"
                    }, null, 8, ["value", "readonly"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "员工姓名",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: employeeForm.value.customerName,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((employeeForm.value.customerName) = $event)),
                      readonly: !!editingEmployee.value,
                      placeholder: "请输入员工姓名"
                    }, null, 8, ["value", "readonly"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "员工信息" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: employeeForm.value.customerInfo,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((employeeForm.value.customerInfo) = $event)),
                      rows: 3,
                      placeholder: "请输入员工信息"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "备注" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: employeeForm.value.remark,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((employeeForm.value.remark) = $event)),
                      rows: 3,
                      placeholder: "请输入备注"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["open", "title", "confirm-loading", "closable", "mask-closable", "keyboard", "cancel-button-props"]),
        _createVNode(_component_a_drawer, {
          open: drawerOpen.value,
          "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((drawerOpen).value = $event)),
          title: "员工餐券详情",
          placement: "right",
          width: drawerWidth.value,
          "destroy-on-close": ""
        }, {
          default: _withCtx(() => [
            (selectedEmployee.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(selectedEmployee.value.customerName), 1),
                        _createElementVNode("div", _hoisted_14, "工号：" + _toDisplayString(selectedEmployee.value.customerId), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-xs text-slate-500" }, "当前餐券余额", -1)),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(formatQuantity(selectedEmployee.value.foodTicketAccount)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        class: "flex-1",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (openAdjustment('add')))
                      }, {
                        default: _withCtx(() => _cache[36] || (_cache[36] = [
                          _createTextVNode("增加餐券", -1)
                        ])),
                        _: 1,
                        __: [36]
                      }),
                      _createVNode(_component_a_button, {
                        danger: "",
                        class: "flex-1",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (openAdjustment('reduce')))
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode("扣减餐券", -1)
                        ])),
                        _: 1,
                        __: [37]
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "mb-1 text-sm text-slate-600" }, "流水日期", -1)),
                      _createVNode(_component_a_range_picker, {
                        value: recordDateRange.value,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((recordDateRange).value = $event)),
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "mb-1 text-sm text-slate-600" }, "变动方向", -1)),
                      _createVNode(_component_a_select, {
                        value: recordDirect.value,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((recordDirect).value = $event)),
                        class: "w-28",
                        "allow-clear": "",
                        placeholder: "全部"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => _cache[39] || (_cache[39] = [
                              _createTextVNode("增加", -1)
                            ])),
                            _: 1,
                            __: [39]
                          }),
                          _createVNode(_component_a_select_option, { value: 2 }, {
                            default: _withCtx(() => _cache[40] || (_cache[40] = [
                              _createTextVNode("减少", -1)
                            ])),
                            _: 1,
                            __: [40]
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: searchRecords
                    }, {
                      default: _withCtx(() => _cache[42] || (_cache[42] = [
                        _createTextVNode("查询流水", -1)
                      ])),
                      _: 1,
                      __: [42]
                    }),
                    _createVNode(_component_a_button, { onClick: resetRecordFilters }, {
                      default: _withCtx(() => _cache[43] || (_cache[43] = [
                        _createTextVNode("重置", -1)
                      ])),
                      _: 1,
                      __: [43]
                    })
                  ]),
                  _createVNode(_component_a_table, {
                    "row-key": "customerAccountRecordId",
                    columns: recordColumns,
                    "data-source": records.value,
                    loading: recordLoading.value,
                    pagination: recordPagination.value,
                    scroll: { x: 1250 },
                    size: "small",
                    onChange: handleRecordTableChange
                  }, {
                    bodyCell: _withCtx(({ column, record }) => [
                      (column.key === 'direct')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: record.direct === 1 ? 'green' : 'red'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.direct === 1 ? '增加' : '减少'), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : (column.key === 'accountQuantity')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(record.direct === 1 ? 'text-green-600' : 'text-red-600')
                            }, _toDisplayString(record.direct === 1 ? '+' : '-') + _toDisplayString(formatQuantity(record.accountQuantity)), 3))
                          : (column.key === 'afterAccountQuantity')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(formatQuantity(calculateAfterQuantity(record))), 1)
                              ], 64))
                            : (column.key === 'source')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createTextVNode(_toDisplayString(record.sourceTypeName || '-') + " ", 1),
                                  (record.sourceCode)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "（" + _toDisplayString(record.sourceCode) + "）", 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                    ]),
                    emptyText: _withCtx(() => _cache[44] || (_cache[44] = [
                      _createTextVNode("暂无餐券流水", -1)
                    ])),
                    _: 1
                  }, 8, ["data-source", "loading", "pagination"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["open", "width"]),
        _createVNode(_component_a_modal, {
          open: adjustmentOpen.value,
          "onUpdate:open": _cache[18] || (_cache[18] = ($event: any) => ((adjustmentOpen).value = $event)),
          title: adjustmentType.value === 'add' ? '增加餐券' : '扣减餐券',
          "confirm-loading": adjustmentLoading.value,
          "ok-text": "确认提交",
          "cancel-text": "取消",
          onOk: submitAdjustment
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_alert, {
              class: "mb-4",
              type: "info",
              "show-icon": "",
              message: `${selectedEmployee.value?.customerName || ''}（工号 ${
            selectedEmployee.value?.customerId || ''
          }）`,
              description: `当前余额：${formatQuantity(selectedEmployee.value?.foodTicketAccount || 0)}`
            }, null, 8, ["message", "description"]),
            _createElementVNode("div", _hoisted_20, [
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "mb-1 text-sm font-medium" }, "调整数量", -1)),
              _createVNode(_component_a_input_number, {
                value: adjustmentQuantity.value,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((adjustmentQuantity).value = $event)),
                class: "w-full",
                min: 0,
                precision: 2,
                placeholder: "请输入大于 0 的数量"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", null, [
              _cache[46] || (_cache[46] = _createElementVNode("div", { class: "mb-1 text-sm font-medium" }, "调整原因", -1)),
              _createVNode(_component_a_textarea, {
                value: adjustmentRemark.value,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((adjustmentRemark).value = $event)),
                maxlength: 200,
                "show-count": "",
                rows: 3,
                placeholder: "请输入调整原因（必填）"
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        }, 8, ["open", "title", "confirm-loading"]),
        _createVNode(_component_a_modal, {
          open: importModalOpen.value,
          "onUpdate:open": _cache[19] || (_cache[19] = ($event: any) => ((importModalOpen).value = $event)),
          title: importType.value === 'add' ? '批量增加餐券' : '批量扣减餐券',
          "confirm-loading": importSubmitting.value,
          "ok-button-props": { disabled: importErrors.value.length > 0 || importRows.value.length === 0 },
          "ok-text": "确认导入",
          "cancel-text": "取消",
          onOk: submitBatchImport,
          onCancel: resetImportState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_alert, {
              class: "mb-3",
              type: importErrors.value.length > 0 ? 'error' : 'success',
              "show-icon": "",
              message: 
            importErrors.value.length > 0
              ? `发现 ${importErrors.value.length} 个问题，请修正后重新选择文件`
              : `校验通过，共 ${importRows.value.length} 名员工`
          
            }, null, 8, ["type", "message"]),
            _createElementVNode("div", _hoisted_21, " 文件：" + _toDisplayString(importFileName.value || '-') + "。表头必须包含“员工工号、员工姓名、餐券数量、调整原因”。 ", 1),
            (importErrors.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(importErrors.value, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error,
                      class: "mb-1 text-sm text-red-600"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_a_table, {
                  key: 1,
                  "row-key": "customerId",
                  columns: importPreviewColumns,
                  "data-source": importRows.value,
                  pagination: { pageSize: 5, hideOnSinglePage: true },
                  size: "small",
                  scroll: { x: 560 }
                }, null, 8, ["data-source"]))
          ]),
          _: 1
        }, 8, ["open", "title", "confirm-loading", "ok-button-props"])
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})